// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { Card } from 'react-bootstrap'
// import Swal from 'sweetalert2'
// import ReactPaginate from 'react-paginate'
// import Loader from 'react-js-loader'
// import loader from '../loder.gif'
// import { Link } from 'react-router-dom'
// import admindata from '../../components/admindata'
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
// import $ from 'jquery';
// import 'datatables.net-dt/css/jquery.dataTables.css';
// import 'datatables.net';
// import { apiRequest } from '../../apiServices/allApi'

// const WalletHistory = () => {
//   const history = useHistory()
//   const [loading, setLoading] = useState(false)
//   const [user, setUser] = useState([])
//   const [startDate, setStartDate] = useState(null)
//   const baseUrl = process.env.REACT_APP_API_BASE_URL;



//   //use for pagination..
//   let [limit, setLimit] = useState(10)

//   const setpageLimit = event => {
//     let key = event.target.value
//     setLimit(key)
//   }
//   const [pageNumber, setPageNumber] = useState(0)
//   const [numberOfPages, setNumberOfPages] = useState(0)
//   const permission1 = localStorage.getItem("PData");
//   const pdata = JSON.parse(permission1);

//   //user for searching..
//   const [searchList, setSearchList] = useState(0)
//   const [searchType, setSearchType] = useState("Phone")
//   const [findByStatus, setFindByStatus] = useState(0)

//   //   searching handler
//   const searchHandler = event => {
//     let key = event.target.value

//     setSearchList(key)
//   }
//   //   search by status handler
//   const searchByStatus = event => {
//     setSearchType("0")
//     let key = event.target.value
//     setFindByStatus(key)
//   }

//   //react paginate..
//   const handlePageClick = async data => {
//     let currentPage = data.selected + 1
//     setPageNumber(currentPage)
//     // scroll to the top
//     //window.scrollTo(0, 0)
//   }

//   const profle =async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//      try {
//           const res = await apiRequest(`history/Security_Deposit/?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}&date=${startDate}`,"GET", null,headers)
//          if (res.data) {
//               setUser(res.data.admin)
//         setNumberOfPages(res.data.totalPages)
//         //$('table').dataTable();
//          }
//             } catch (e) {
//               setLoading(false);
//             }
//             finally {
//             }
//   }



//  const dateFormat = (e) => {
//     const date = new Date(e);
//     const newDate = date.toLocaleString("default", {
//       month: "long",
//       day: "numeric",
//       hour: "numeric",
//       hour24: true,
//       minute: "numeric",
//     });
//     return newDate;
//   };


//     const imageopen = (image) => {
//       Swal.fire({
//         title: "Pay Qr Code",
//         text: "",

//         imageUrl: baseUrl+`/${image}`,
//         imageWidth: 400,
//         imageHeight: 300,
//         imageAlt: "Custom image"
//       })
//     }


//   function daterange (s, e) {
//     if (s) {
//       setStartDate(s)
//     }
     
//     }

//   useEffect(() => {
//     profle()
//   }, [pageNumber, limit, searchList, searchType, findByStatus, startDate])

//   if (user == undefined) {
//     return null
//   }

//   const Invoice = data => {
//     const userData = { data }
//     // setUser(userData);
//     console.log(userData)
//     history.push('/invoice', { userData })
//   }

//   return loading ? (
//     <>
//       <div className='App'>
//         <div className='item dashboaed_loader'>
//           <Loader
//             type='bubble-ping'
//             bgColor={'#fff'}
//             title={<img src={loader} alt='Loading...' />}
//             color={'#000'}
//             size={100}
//           />
//         </div>
//       </div>
//     </>
//   ) : (
//     <>
//       {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
//       <div className='row mt-5'>
//         <div className='col-12 grid-margin'>
//           <div className='card '>
//             <div className='card-body text-light table_bg'>
//               <h4 className='dashboard_heading'>Agent Wallet History</h4>

//               {/* searching */}
//               <div className='row'>
//                 <select
//                   className='form-control col-sm-3 m-2'
//                   id='searchType'
//                   name='searchtype'
//                   onChange={e => setSearchType(e.target.value)}
//                 >
//                   <option value='0'>Select Search by</option>
//                   <option value='Phone'>Phone</option>
//                   <option value='_id'>TxnId</option>
//                   <option value='amount'>Amount</option>
//                 </select>
//                 <input
//                   type='text'
//                   placeholder='Search...'
//                   className='form-control col-sm-4 m-2'
//                   onChange={searchHandler}
//                 />
               
//                 <select
//                   className='form-control col-sm-1 m-1 bg-dark text-light'
//                   id='pagelimit'
//                   name='pagelimit'
//                   onChange={setpageLimit}
//                 >
//                   <option value='10'>Set limit</option>
//                   <option value='20'>20</option>
//                   <option value='50'>50</option>
//                   <option value='100'>100</option>
//                   <option value='500'>500</option>
//                 </select>
// {/* 
//                 <input
//               type="datetime-local"
//               name="DOB"
//               placeholder="Select Data"
//               value={startDate}   onChange={(e) => daterange(e.target.value)}
//               required
//             /> */}
//               </div>

//               <div className='table-responsive'>
//                 <table className='table text-light'>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                       <th> ID</th>
//                    <th>Name</th>
//                    <th>Phone</th>
//                    <th>Amount</th>
//                    <th>screenshot</th>
//                    <th>Action By</th>
//                    <th>Reason</th>
//                    <th>Status</th>
//                    <th>Date</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {user &&
//                       user.map((data, key) => {
//                         return (
//                           <tr>
//                             <td>{key + 1}</td>
//                             <td>{data?._id}</td>
//                              <td>
//                                                       {data?.Admin_id && (
//                                                         <Link
//                                                           className='btn btn-sm btn-outline-info'
//                                                           to={`/Agent/Data/${data?.Admin_id?.id}`}
//                                                         >
//                                                           {data?.Admin_id?.Name}
//                                                         </Link>
//                                                       )}
//                                                     </td>
//                             <td>{data?.Admin_id?.Phone}</td>
//                             <td>{data.amount}</td>

//                             <td>
//                           <img src={`${baseUrl}/${data?.paymentImage}`}
//                           onClick={() => imageopen(data.paymentImage)}
//                           onError={(e) => {
//                             e.target.onerror = null;
//                             e.target.src = "/error.png";
//                           }}
//                           />
//                         </td>
//                         <td>{data?.action_by?.Name}</td>
//                         <td>{data?.txn_msg}</td>
//                         <td
//                           style={{
//                             color:
//                             data?.status == "Penalty by Admin"
//                                 ? "red"
//                                 : "black"
//                                   ,
//                           }}
//                         >{data?.status}</td>
//                         <td>{dateFormat(data.createdAt)}</td>
//                           </tr>
//                         )
//                       })}
//                   </tbody>
//                 </table>
//               </div>

//               <div className='mt-4'>
//                 <ReactPaginate
//                   previousLabel={'Previous'}
//                   nextLabel={'Next'}
//                   breakLabel={'...'}
//                   pageCount={numberOfPages}
//                   marginPagesDisplayed={2}
//                   pageRangeDisplayed={3}
//                   onPageChange={handlePageClick}
//                   containerClassName={'pagination justify-content-center'}
//                   pageClassName={'page-item'}
//                   pageLinkClassName={'page-link'}
//                   previousClassName={'page-item'}
//                   previousLinkClassName={'page-link'}
//                   nextClassName={'page-item'}
//                   nextLinkClassName={'page-link'}
//                   breakClassName={'page-item'}
//                   breakLinkClassName={'page-link'}
//                   activeClassName={'active'}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default WalletHistory


import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import Swal from 'sweetalert2'
import ReactPaginate from 'react-paginate'
import Loader from 'react-js-loader'
import loader from '../loder.gif'
import { Link } from 'react-router-dom'
import admindata from '../../components/admindata'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net';
import { apiRequest } from '../../apiServices/allApi'
// import './WalletHistory.css'

const WalletHistory = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState([])
  const [startDate, setStartDate] = useState(null)
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  // Pagination states
  let [limit, setLimit] = useState(10)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)
  const permission1 = localStorage.getItem("PData");
  const pdata = JSON.parse(permission1);

  // Search states
  const [searchList, setSearchList] = useState(0)
  const [searchType, setSearchType] = useState("Phone")
  const [findByStatus, setFindByStatus] = useState(0)

  const searchHandler = event => {
    let key = event.target.value
    setSearchList(key)
  }

  const searchByStatus = event => {
    setSearchType("0")
    let key = event.target.value
    setFindByStatus(key)
  }

  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
  }

  const profle = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`history/Security_Deposit/?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}&date=${startDate}`, "GET", null, headers)
      if (res.data) {
        setUser(res.data.admin)
        setNumberOfPages(res.data.totalPages)
      }
    } catch (e) {
      setLoading(false);
    }
  }

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour24: true,
      minute: "numeric",
    });
    return newDate;
  };

  const imageopen = (image) => {
    Swal.fire({
      title: "Pay Qr Code",
      text: "",
      imageUrl: baseUrl + `/${image}`,
      imageWidth: 400,
      imageHeight: 300,
      imageAlt: "Custom image"
    })
  }

  function daterange(s, e) {
    if (s) {
      setStartDate(s)
    }
  }

  useEffect(() => {
    profle()
  }, [pageNumber, limit, searchList, searchType, findByStatus, startDate])

  if (user == undefined) {
    return null
  }

  const Invoice = data => {
    const userData = { data }
    console.log(userData)
    history.push('/invoice', { userData })
  }

  return loading ? (
    <div className='App'>
      <div className='item dashboaed_loader'>
        <Loader
          type='bubble-ping'
          bgColor={'#fff'}
          title={<img src={loader} alt='Loading...' />}
          color={'#000'}
          size={100}
        />
      </div>
    </div>
  ) : (
    <div className='wallethistory-page-container'>
      <div className='wallethistory-main-card'>
        <h4 className='wallethistory-heading-main'>Agent Wallet History</h4>

        {/* Filter Bar Controls */}
        <div className='wallethistory-filter-bar'>
          <select
            className='custom-wallethistory-input'
            id='searchType'
            name='searchtype'
            onChange={e => setSearchType(e.target.value)}
          >
            <option value='0'>Select Search by</option>
            <option value='Phone'>Phone</option>
            <option value='_id'>TxnId</option>
            <option value='amount'>Amount</option>
          </select>

          <input
            type='text'
            placeholder='Search Keyword...'
            className='custom-wallethistory-input'
            onChange={searchHandler}
          />

          <select
            className='custom-wallethistory-input'
            id='pagelimit'
            name='pagelimit'
            onChange={setpageLimit}
          >
            <option value='10'>Limit: 10</option>
            <option value='20'>Limit: 20</option>
            <option value='50'>Limit: 50</option>
            <option value='100'>Limit: 100</option>
            <option value='500'>Limit: 500</option>
          </select>
        </div>

        {/* Responsive Table Content */}
        <div className='table-responsive-wrapper'>
          <table className='wallethistory-modern-table'>
            <thead>
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Amount</th>
                <th>Screenshot</th>
                <th>Action By</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {user &&
                user.map((data, key) => (
                  <tr key={data?._id || key}>
                    <td>{key + 1}</td>
                    <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{data?._id}</td>

                    <td>
                      {data?.Admin_id && (
                        <Link
                          className='agent-link-item'
                          to={`/Agent/Data/${data?.Admin_id?.id}`}
                        >
                          {data?.Admin_id?.Name}
                        </Link>
                      )}
                    </td>

                    <td style={{ color: '#34d399', fontWeight: 600 }}>{data?.Admin_id?.Phone}</td>

                    <td>
                      <span className='amount-text-bold'>₹{data.amount}</span>
                    </td>

                    <td>
                      <img
                        src={`${baseUrl}/${data?.paymentImage}`}
                        alt='Proof'
                        className='screenshot-proof-thumb'
                        onClick={() => imageopen(data.paymentImage)}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/error.png";
                        }}
                      />
                    </td>

                    <td style={{ color: '#a5b4fc', fontWeight: 600 }}>
                      {data?.action_by?.Name ?? "----"}
                    </td>

                    <td style={{ color: '#cbd5e1' }}>{data?.txn_msg}</td>

                    <td className={data?.status === "Penalty by Admin" ? "status-badge-penalty" : ""}>
                      {data?.status}
                    </td>

                    <td>{dateFormat(data.createdAt)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Container */}
        <div className='pagination-container'>
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={numberOfPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination justify-content-center'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}
          />
        </div>

      </div>
    </div>
  )
}

export default WalletHistory